import { Field } from "formik";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputNumberAsString,
  SearchableList,
} from ".";
const componentMapping = {
  Field: Field,
  FieldInput: FieldInput,
  FieldButtonGroup: FieldButtonGroup,
  FieldDropSide: FieldDropSide,
  SearchableList: SearchableList,
};

export default componentMapping;
